import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import LinkButton from '../../components/link-button'

class UICulturalCreativeWorksDetails extends Component {

    /////////////////////////////////////////////////////////////     
    render() {
        const { ObjectCollectionNid } = this.props.location.state
        const title = (
            <span>
                <LinkButton><ArrowLeftOutlined style={{ color: 'green', marginRight: 15, fontSize: 20 }} onClick={() => this.props.history.goBack()} /></LinkButton>
                項目明細
            </span>
        )
        return (
           <Card title={title}>{ObjectCollectionNid}</Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(UICulturalCreativeWorksDetails)